import { useState } from 'react';

export default function VideoSection() {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            See Goodys Streams in Action
          </h2>
          <p className="text-xl text-gray-600">
            Watch how easy it is to get started with our premium streaming service
          </p>
        </div>

        {/* Video Player */}
        <div className="relative rounded-2xl overflow-hidden shadow-2xl mb-12">
          <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
            <iframe
              src="https://drive.google.com/file/d/1IxuQvOWEGgK81XUTOnpXFHqfCgNAJBIA/preview"
              className="absolute inset-0 w-full h-full"
              allow="autoplay"
              allowFullScreen
              title="Goodys Streams Demo Video"
            ></iframe>
          </div>
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <a 
            href="https://wa.me/qr/QOVGSHQTONIKJ1"
            className="inline-flex items-center space-x-3 bg-gradient-to-r from-orange-500 to-red-500 text-white px-8 py-4 rounded-full font-semibold hover:from-orange-600 hover:to-red-600 transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
          >
            <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-whatsapp-line text-xl"></i>
            </div>
            <span className="text-lg">Start Your Free Trial</span>
          </a>
        </div>
      </div>
    </section>
  );
}
